export const FlowChain = ({ steps, connector = "→", testId }) => (
  <div className="flow-chain" data-testid={testId}>
    {steps.map((step, i) => (
      <span className="flow-chain-item" key={i}>
        <span className="flow-step">{step}</span>
        {i < steps.length - 1 && <span className="flow-arrow" aria-hidden="true">{connector}</span>}
      </span>
    ))}
  </div>
);
